// ** React Imports
import { ReactNode, useContext } from 'react'

// ** Component Imports
import { AbilityContext } from 'src/layouts/components/acl/Can'
import { useAuth } from '@/src/hooks/useAuth'

// ** Types
import { NavLink } from 'src/@core/layouts/types'

interface Props {
  navLink?: NavLink
  children: ReactNode
}

const CanViewNavLink = (props: Props) => {
  // ** Props
  const { children, navLink } = props

  // ** Hooks
  const ability = useContext(AbilityContext)
  const auth = useAuth()

  if (navLink && navLink.auth === false) {
    return <>{children}</>
  }

  // If custom permission check is provided, use it
  if (navLink?.customPermissionCheck && auth.user) {
    return navLink.customPermissionCheck(auth.user) ? <>{children}</> : null
  }

  // Otherwise, use the standard ability check
  return ability && ability.can(navLink?.action, navLink?.subject) ? <>{children}</> : null
}

export default CanViewNavLink
